import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectorFotosOriginals,
    selectorFotosEliminades,
    selectorFotosCreades,
    selectorFotosOriginalsMenysFotosEliminades } from '../../selectors/selector_estacio_formulari_dades';
import { selectorNumeroMaximDeFotos,
    selectorMidaMaximaFotosEnBytes } from '../../selectors/selector_estacio_formulari_estructura';

import EstacioIntroduccioSelectorImatge from './estacioIntroduccioSelectorImatge';

import { estacioIntroduccioFotosCrearFoto, estacioIntroduccioFotosEliminarFoto,
    estacioIntroduccioFotosDescartarFoto } from '../../actions';

class EstacioIntroduccioFoto extends Component {

    descartarFoto(indexFotoCreadaADescartar) {
        this.props.estacioIntroduccioFotosDescartarFoto(indexFotoCreadaADescartar);
    }

    eliminarFoto(indexFotoAEliminar) {
        const { fotosOriginalsMenysFotosEliminades } = this.props;
        const fotoAEliminar = fotosOriginalsMenysFotosEliminades[indexFotoAEliminar];
        this.props.estacioIntroduccioFotosEliminarFoto(fotoAEliminar);
    }

    crearFoto(fitxerACrear) {
        this.props.estacioIntroduccioFotosCrearFoto(fitxerACrear);
    }

    render() {
        const { fotosCreades, fotosOriginalsMenysFotosEliminades, numMaximDeFotos, midaMaximaFotosEnBytes, fotosOriginals } = this.props;

        if (!fotosOriginals) return null;

        const numFotosAMostrar = fotosOriginalsMenysFotosEliminades.length + fotosCreades.length;

        const botoAfegirFoto = (
            <EstacioIntroduccioSelectorImatge
                urlImatgeOriginal={null}
                midaMaximaFotosEnBytes={midaMaximaFotosEnBytes}
                eliminarFoto={this.descartarFoto.bind(this, fotosCreades.length)}
                crearFoto={this.crearFoto.bind(this)} />
        );

        const selectorsImatgesOriginalsMenysEliminades = () => {
            return fotosOriginalsMenysFotosEliminades.map((foto, index) => {
                return <EstacioIntroduccioSelectorImatge
                    key={index}
                    urlImatgeOriginal={foto.url}
                    midaMaximaFotosEnBytes={midaMaximaFotosEnBytes}
                    eliminarFoto={this.eliminarFoto.bind(this, index)}
                    crearFoto={this.crearFoto.bind(this)} />;
            });
        };

        const selectorsImatgesCreades = () => {
            return fotosCreades.map((foto, index) => {
                return <EstacioIntroduccioSelectorImatge
                    key={index}
                    urlImatgeOriginal={foto.url}
                    midaMaximaFotosEnBytes={midaMaximaFotosEnBytes}
                    eliminarFoto={this.descartarFoto.bind(this, index)}
                    crearFoto={this.crearFoto.bind(this)} />;
            });
        };

        const mostrarFotosOriginalsMenysEliminades = selectorsImatgesOriginalsMenysEliminades();
        const mostrarFotosCreades = selectorsImatgesCreades();

        return (
            <div className='estacio-introduccio-foto'>
                {mostrarFotosOriginalsMenysEliminades} {mostrarFotosCreades}
                {numFotosAMostrar < numMaximDeFotos ? botoAfegirFoto : null}
            </div>
        );
    }
}

EstacioIntroduccioFoto.propTypes = {
    fotosOriginals: PropTypes.array,
    fotosEliminades: PropTypes.array,
    fotosCreades: PropTypes.array,
    fotosOriginalsMenysFotosEliminades: PropTypes.array,
    numMaximDeFotos: PropTypes.number,
    midaMaximaFotosEnBytes: PropTypes.number,
    estacioIntroduccioFotosEliminarFoto: PropTypes.func,
    estacioIntroduccioFotosCrearFoto: PropTypes.func,
    estacioIntroduccioFotosDescartarFoto: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        fotosOriginals: selectorFotosOriginals(state),
        fotosEliminades: selectorFotosEliminades(state),
        fotosCreades: selectorFotosCreades(state),
        fotosOriginalsMenysFotosEliminades: selectorFotosOriginalsMenysFotosEliminades(state),
        numMaximDeFotos: selectorNumeroMaximDeFotos(state),
        midaMaximaFotosEnBytes: selectorMidaMaximaFotosEnBytes(state)
    };
};

const mapDispatchToProps = {
    estacioIntroduccioFotosCrearFoto,
    estacioIntroduccioFotosEliminarFoto,
    estacioIntroduccioFotosDescartarFoto
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioFoto);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioFoto.js